import React, { createContext, useContext, useState } from "react";

const AppContext = createContext({
  user: null,
  setUser: () => {},
});

export const AppWrapper = ({ children }) => {
  const [user, setUser] = useState(null);

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
